// @ts-check
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * @typedef {object} AuthState
 * @property {string | null} token
 * @property {string | null} role
 * @property {(token: string, role: string) => void} setToken
 * @property {() => void} clear
 */

/** @type {import('zustand').UseBoundStore<import('zustand').StoreApi<AuthState>>} */
export const useAuth = create(persist(
  (set) => ({
    token: null,
    role: null,
    setToken: (token, role) => set({ token, role }),
    clear: () => set({ token: null, role: null }),
  }),
  { name: 'katsura-hq-auth' },
));
